export const componentsMap = {
    IslamicResourceTiles: () => import('../components/related-islamic-resources/IslamicResourceTiles'),
    IslamicResourcesSlide: () => import('../components/related-islamic-resources/IslamicResourcesSlide'),
    AffiliatesComponent: () => import('../components/related-islamic-resources/AffiliatesComponent'),
    SocialMediaIconsFooter: () => import('../components/ui-elements/SocialMediaIconsFooter'),
    SocialMediaIconsFooterMobile: () => import('../components/ui-elements/SocialMediaIconsFooterMobile'),
    ExpandableMenuContainer: () => import('../components/navbar/ExpandableMenuContainer'),
    SidebarContainer: () => import('../components/settings-sidebar/SidebarContainer'),
    ProfilePic: () => import('../components/ui-elements/ProfilePic'),
    ProfilePicToggle: () => import('../components/ui-elements/ProfilePicToggle'),
};